// There is only one action in allWeekIds Actions at the moment
import Creators from './actions';

const { updateAllWeekIdsByRetailerId } = Creators;

// There is only one so exporting and picking it up in exterior files
export default updateAllWeekIdsByRetailerId;
